/** @jsx jsx */
import { Fragment } from 'react'
import { jsx } from 'theme-ui'
import ListingAddToCartButton from '~/components/Listing/AddToCart/Button'
import PackAddToCartDropdown from '~/components/Pack/AddToCart/Dropdown'
import { getAvailablePackKits } from '~/utils/packs'

const PackCardAddToCart = ({ pack }) => {
  const availableKits = getAvailablePackKits(pack)
  const { comingSoon, preorderDate, soldOut } = pack

  return (
    <Fragment>
      {availableKits?.length > 1 && <PackAddToCartDropdown pack={pack} />}
      {availableKits?.length === 1 && (
        <ListingAddToCartButton
          comingSoon={comingSoon}
          preorderDate={preorderDate}
          showPrice={true}
          sku={availableKits[0].sku}
          soldOut={soldOut}
        />
      )}
    </Fragment>
  )
}

export default PackCardAddToCart
